export enum FallbackMethods {
  SV = 'SV',
  CAIA = 'CAIA',
  OFFICE = 'OFFICE',
}
